
<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2021-06-03 04:36:12
    Description : 审核列表的卡片
  -->
  <div class="manage-card">
    <!-- <img class="cover" :src="baseUrl + data.cover" onerror="this.imgError" /> -->
    <el-image
      class="cover"
      :src="baseUrl + data.cover"
      fit="cover"
      :style="{ height: `${height}px` }"
    >
      <div slot="error" class="image-slot">
        <img
          class="cover"
          src="@/assets/images/default-cover.png"
          :style="{ height: `${height}px` }"
        />
      </div>
    </el-image>
    <div class="info">
      <div class="title">{{ data.title }}</div>
      <div class="time" :style="{ opacity: data.duration !== -1 ? 1 : 0 }">
        {{ timeConversion(data.duration) }}
      </div>
      <div class="size" :style="{ opacity: data.size !== -1 ? 1 : 0 }">
        {{ getSize(data.size) }}
      </div>
      <div class="operate" :style="{ top: `-${height + 30}px` }">
        <div class="btn" @click="$emit('delClick')">
          <delete theme="outline" size="18" fill="#fff" />
        </div>
        <div class="btn" @click="$emit('editClick')">
          <Write theme="outline" size="18" fill="#fff" />
        </div>
      </div>
    </div>
    <div class="state" v-if="!['reviewPassed', 'pass'].includes(data.state)">
      <div class="background">
        <div class="state">{{ state[data.state] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { timeConversion, getSize } from "@/utils/utils";
import { Write, Delete } from "@icon-park/vue";
export default {
  components: {
    Write,
    Delete,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    height: {
      type: Number,
      default: 136,
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      state: {
        reviewPassed: "审核通过",
        pass: "审核通过",
        processingFailure: "处理失败",
        reviewFailed: "审核未通过",
        notPass: "审核未通过",
        reviewPending: "待审核",
        waitting: "待审核",
        uploading: "上传中",
        processing: "转码中",
      },
    };
  },
  watch: {
    data(v) {
        if (v) {
            console.log(this.data.state);
        }
    },
  },
  created() {
    if (this.data) {
      console.log(this.data.state);
    }
  },
  methods: {
    timeConversion(duration) {
      if (duration) {
        return timeConversion(duration);
      } else {
        return "-- : --";
      }
    },
    getSize(size) {
      return getSize(size);
    },
    imgError() {
      //
      console.log("error");
    },
  },
};
</script>

<style lang="less" scoped>
.manage-card {
  display: inline-block;
  width: 272px;
  margin-bottom: 20px;
  overflow: hidden;
  user-select: none;
}
.cover {
  display: block;
  width: 272px;
  height: 136px;
}
.info {
  width: 272px;
  height: 30px;
  padding: 4px;
  font-size: 14px;
  color: #616161;
  border: 1px solid #e7e7e7;
  .title {
    width: 76%;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; //溢出不换行
  }
  .time {
    display: inline-block;
    position: relative;
    top: -60px;
    left: 201px;
    width: auto;
    max-width: 70px;
    height: 22px;
    line-height: 22px;
    padding: 0 7px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 600;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    color: #fff;
  }
  .size {
    display: inline-block;
    position: relative;
    top: -20px;
    left: 154px;
    padding: 0 2px;
    font-size: 12px;
    border-radius: 2px;
    text-align: center;
    color: #ffffff;
    background: #b2b2b2;
  }
}
.operate {
  position: relative;
  top: -170px;
  left: 230px;
  height: 0px;
  z-index: 100;
  .btn {
    width: 28px;
    height: 28px;
    line-height: 32px;
    border-radius: 50%;
    margin-bottom: 6px;
    text-align: center;
    background: rgba(255, 255, 255, 0.3);
    border: #ffffff solid 2px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .btn:hover {
    border: rgba(255, 255, 255, 0.4) solid 2px;
    background: rgba(255, 255, 255, 0.4);
    transition: all 0.2s;
  }
  .btn:active {
    background: rgba(255, 255, 255, 0.3);
    border: #ffffff solid 2px;
    transition: all 0.2s;
  }
}
.state {
  position: relative;
  width: 272px;
  height: 0;
  top: -166px;
  left: 0;
  z-index: 99;
  .background {
    width: 100%;
    height: 136px;
    padding-left: 88px;
    background: rgba(0, 0, 0, 0.4);
    .state {
      position: relative;
      top: 54px;
      width: 100px;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      background: linear-gradient(to right, #d92758 0%, #ff464c 100%);
    }
  }
}
</style>
